export default __webpack_public_path__ + "static/media/setaBaixaVermelha2.e230bb3b.svg";